import { IState } from '../state/state';
import { createSelector } from '@ngrx/store';
import { IUserRootObject, IPayload } from 'src/app/models/user';
import { appSelector } from '../state/state.selector';

export const userDetailsSelector = (state: IState) => state.appData.userDetails;
export const userDetailsPermissionSelector = (state: IState) => state.appData.userDetails;

export const userDetailsMessage = createSelector(userDetailsSelector, (state: IUserRootObject) => state.message);
export const userDetailsPayload = createSelector(userDetailsSelector, (state: IUserRootObject) => state.payload);

export const userDetailsPermissionsFacilitySelector = createSelector(userDetailsPayload, (state: IPayload) => state.permissionMapping);


export const userDetailsActiveCheckinSelector = createSelector(userDetailsSelector,
  (state: IUserRootObject) => state.payload?.activeCheckIn);
export const userDetailRecentCheckInSelector = createSelector(userDetailsSelector,
  (state: IUserRootObject) => state.payload?.recentCheckIns?.lastTen);


export const userDetailProxyActiveCheckInSelector = createSelector(userDetailsSelector,
  (state: IUserRootObject) => state.payload?.proxyActiveCheckIns);
export const TabSelector = createSelector(appSelector, state => state.selectedTab);

export const isHistorySelector = createSelector(appSelector, state => state.isHistory);

export const previousURLSelector = createSelector(appSelector, state => state.previousUrl);

export const requestURLSelector = createSelector(appSelector, state => state.requestUrl);


export const addNewSelector = createSelector(appSelector, state => state.addNew);


export const userPermissions = createSelector(appSelector, state => state.userPermission);

export const recentTwoCheckinSelector = createSelector(userDetailsPayload, state => state.recentCheckIns?.lastTwo);

